import { Component } from "react";
import PropTypes from "prop-types";
import { GeolocateControl as MapboxGeolocateControl } from "mapbox-gl";

class GeolocateControl extends Component {
  static contextTypes = { map: PropTypes.object.isRequired };

  componentDidMount() {
    const { map } = this.context;
    this.geolocateControl = new MapboxGeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    });

    map.addControl(this.geolocateControl);
  }

  render() {
    return null;
  }

  trigger() {
    setTimeout(() => {
      this.geolocateControl.trigger();
    }, 2000);
  }
}

export default GeolocateControl;



// WEBPACK FOOTER //
// ./src/NewRoute/components/GeolocateControl.js